export default {
  signin: {
    title: "Авторизація",
    userForm: {
      username: {
        placeholder: "Користувач"
      },
      password: {
        placeholder: "Пароль"
      },
      language: {
        placeholder: "Мова"
      },
      connection: {
        placeholder: "Підключення"
      },
      server: {
        placeholder: "Сервер"
      },
      section: {
        placeholder: "Секція"
      },
      base: {
        placeholder: "База"
      },
      signin: "Вхід"
    },
    userRules: {
      username: {
        required: "Необхідно ввести ім'я користувача",
        min: "Ім'я користувача повинно бути не менше 3 символів",
        max: "Ім'я користувача повинно бути не більше 24 символів"
      },
      password: {
        required: "Необхідно ввести пароль",
        min: "Довжина пароля повинна бути не менше 3 символів",
        max: "Довжина пароля повинна бути не більше 24 символів"
      },
      language: {
        required: "Необхідно вибрати мову"
      },
      connection: {
        required: "Необхідно вибрати підключення"
      },
      server: {
        required: "Необхідно вибрати сервер"
      },
      section: {
        required: "Необхідно вибрати секцію"
      },
      base: {
        required: "Необхідно вибрати базу"
      }
    },
    version: {
      current: "Версія:",
      serverMin: "Cервер (мін.):",
      apiMin: "API (мін.):"
    }
  }
};
